import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Button from "@atoms/Button";
import Link from "@atoms/Link";

import CheckoutPaymentIntl from "@pages/CheckoutPayment/CheckoutPaymentIntl";
import CheckoutPaymentKr from "@pages/CheckoutPayment/CheckoutPaymentKr";

import { URLS } from "@const/urls";

import useLanguage from "@hooks/useLanguage";

export default function CheckoutPayment() {
  const navigate = useNavigate();

  const { lang } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="pc:col-start-3 pc:w-full pc:min-w-160 pc:max-w-200 pc:place-self-center relative col-span-8 flex flex-col">
      <section className="flex items-center justify-between p-5">
        <Link className="text-title font-features-normal" href={URLS.HOME}>
          thisisneverthat®
        </Link>
      </section>

      <section className="pc:p-5 flex flex-col gap-5">
        <Button
          as="text"
          onClick={() => {
            const checkoutBackUrl = sessionStorage.getItem("checkoutBackUrl");
            if (checkoutBackUrl) navigate(checkoutBackUrl);
            else navigate(-1);

            sessionStorage.removeItem("checkoutBackUrl");
          }}
        >
          ← Back
        </Button>
        {lang === "ko" ? <CheckoutPaymentKr /> : <CheckoutPaymentIntl />}
      </section>
    </section>
  );
}
